import { render, staticRenderFns } from "./TrainingForm.vue?vue&type=template&id=0900a815&scoped=true"
import script from "./TrainingForm.vue?vue&type=script&lang=js"
export * from "./TrainingForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0900a815",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0900a815')) {
      api.createRecord('0900a815', component.options)
    } else {
      api.reload('0900a815', component.options)
    }
    module.hot.accept("./TrainingForm.vue?vue&type=template&id=0900a815&scoped=true", function () {
      api.rerender('0900a815', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/referentiel/parameters/Training/TrainingForm.vue"
export default component.exports